/**
 * МЗЦ — минимальная закупочная цена.
 *
 * Зеркало backend/services/calculator.py::calculate_min_purchase_price.
 * Живой калькулятор считает экономику на клиенте, поэтому формула нужна и здесь;
 * прибыль при этом НЕ пересчитывается — на вход идёт уже посчитанный
 * profit/unit со всеми расходами и без launch budget.
 */

/**
 * Маржа, на которую считается МЗЦ.
 * Документ «Пайплайн 3_08», приоритет 1: «маржа для расчёта берётся 30%».
 * Доля, а не проценты — чтобы формула читалась как в ТЗ (Price × 0,3).
 */
export const MIN_PURCHASE_PRICE_TARGET_MARGIN = 0.3;

/**
 * МЗЦ = Profit/unit (со всеми расходами, без launch budget)
 *     + Purchase $ (если есть) − Price × 0,3.
 *
 * Прибыль на единицу линейна по закупочной цене с коэффициентом −1, поэтому
 * `profit + purchase` — это прибыль при нулевой закупке, а результат не зависит
 * от того, введена себестоимость или нет.
 */
export function calcMinPurchasePrice(
  profitPerUnitWithCosts: number,
  purchasePrice: number,
  sellingPrice: number,
  targetMargin: number = MIN_PURCHASE_PRICE_TARGET_MARGIN,
): number {
  return profitPerUnitWithCosts + purchasePrice - sellingPrice * targetMargin;
}
